import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { LayoutComponent} from'src/app/layout/layout.component';
import { filter } from 'rxjs/internal/operators/filter';
@Component({
  selector: 'app-wmsm-StatementMaintain',
  templateUrl: './wmsm-StatementMaintain.component.html',
  styleUrls: ['./wmsm-StatementMaintain.component.scss']
})
export class WmsmStatementMaintainComponent extends BaseComponent implements OnInit {
  loading: boolean = false;
  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  listOfData: any[] = [];
  validateForm: FormGroup;
  formValues: any;

  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private Environment: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private LayoutComponent:LayoutComponent,
    private router: Router,

  ) { super()
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe((event: NavigationStart) => {
      console.log(event.url ,"event.url ")
      const urlParts = this.router.url.split('?');
      const cleanUrl = urlParts[0];
      if (event.url === '/pages/wmsm-pages/SupplierManagement/StatementPaymentManagement/wmsmStatementMaintain') {

        if (cleanUrl.indexOf("/pages/wmsm-pages/wmsmStatementMaintain-edit") !== -1) {
         // this.getResultData();
        } else if (cleanUrl.indexOf("/pages/wmsm-pages/wmsmStatementMaintain-edit") == -1) {
          // 不是编辑页跳转过来的，走ngOninit
          this.ngOnInit();
          //this.getResultData();
          this.listOfData = [];
          this.nzTotal = 0;
        }
      }
    });
  }

  ngOnInit() {
    this.validateForm = this.fb.group({
      StatementNo: [''],
    });

    this.matomotracker.trackPageView("供應商管理")
    this.matomotracker.trackEvent("供應商管理","CN對賬單維護","Transation",1);
setTimeout(() => {
  this.LayoutComponent.geturl()
}, 20);
  }

  getFormValue(value) {
    this.formValues = value;
    if(!this.AuthService.StatementMaintainData){
      //this.getResultData();
    }
    else{
      // this.listOfData=this.AuthService.StatementMaintainData;
      // this.nzTotal=this.AuthService.StatementMaintainDataTotal;
    }

  }

  getQuery(value) {
    this.isShowCondition = value;
  }
  onSearch() {

    this.getResultData()
  }
  // 获取查询表格数据
  getResultData() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.QueryRtStatementToDoList.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Rno: this.formValues.RNO,
        RoleType:sessionStorage.getItem('Whqrole'),
        SiteNo:this.formValues.Site,
        Buyer:this.formValues.Buyer,
        VendorCode:this.formValues.Vendor
      },
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (
          res &&
          res.status == this.Environment.authConfig.wmsmStatus
        ) {
          this.listOfData = res.data.map((item) => {
            item.statementMonth = this.getTheDateString_YM(item.statementMonth);
            item.acDate = DateUtil.formatYMD(item.acDate);
            return item;
          });
          this.nzTotal = res.total;
          this.AuthService.StatementMaintainData=this.listOfData;
          this.AuthService.StatementMaintainDataTotal=res.total;
          this.NzMessageService.success(res.msg);
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
          this.NzMessageService.warning(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
      }
    );
  }

  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }
  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }
  RnoOnClick(rNo: string, currency: string, vendorCode: string, companyERP: string) {
  this.router.navigate(['/pages/wmsm-pages/wmsmStatementMaintain-edit'], {
    queryParams: {
      rno: rNo,
      currency: currency,
      vendorCode: vendorCode,
      companyERP: companyERP // 2. 將 companyERP 添加到 queryParams
    }
  });
}



  onQueryClick():string {
    return 'StatementMaintain';
  }


  sortChange(e) {
    this.listOfData = e === 'ascend' ? this.listOfData.sort(
      (a, b) => a.rNo.localeCompare(b.rNo)
    ) : this.listOfData.sort(
      (a, b) => b.rNo.localeCompare(a.rNo)
    )
  }

  exportTableToExecl() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownLoadRtStatementMaintainExcel.url}`;
    const params = {
      data: {
        Buyer:this.formValues.Buyer,
        SiteNo:this.formValues.Site,
        Rno: this.formValues.RNO,
        VendorCode:this.formValues.Vendor
      },
    };
    this.WebApiService.doPost(url, params, true).subscribe((res) => {
      this.downloadFile8(res, `CHN_Payment_Maintain_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }
}
